import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

export const ShadowUserRoleGrid = () => {
  const rows = [];

  for (let i = 0; i < 4; i++) {
    rows.push(
      <Grid container key={i}>
        <Grid item xs={4}>
          <div className="m-shadow-user-roles-grid__shadow-role-card"></div>
        </Grid>
        <Grid item xs={4}>
          <div className="m-shadow-user-roles-grid__shadow-role-card"></div>
        </Grid>
        <Grid item xs={4}>
          <div className="m-shadow-user-roles-grid__shadow-role-card"></div>
        </Grid>
      </Grid>,
    );
  }

  return <div className="m-shadow-user-roles-grid__container">{rows}</div>;
};

export const ShadowRoleForm = () => {
  const rows = [];

  for (let i = 0; i < 10; i++) {
    rows.push(<div className="m-role-form__shadow-form" key={i} />);
  }

  return rows;
};
